export class AbstractMethodNotImplemented extends Error {
  constructor(methodName) {
    super(
      `The method named "${methodName}" should be implemented by the one of the sub classes but it was not`,
    );
    this.name = 'AbstractMethodNotImplemented';
  }
}
